import '../../controllers/enterprise_admin';
import middlewares from '../../modules/analytics/middlewares/enterpriseAdminApplication';
import analytics from '../../modules/analytics';

analytics.init(middlewares);
